import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';
import { Spinner, Col, Row } from 'react-bootstrap';

import { useStore } from '../../store';
import { Auth, Http } from '../../support';
import ClienteTaxInfo from './info/ClienteTaxInfo';
import Loading from '../../facturotopia/loading/Loading';
import LoadingButton from '../../facturotopia/LoadingButton';
import PageHeader from '../../support/page-header/PageHeader';
import ClienteAssignacionHits from './edit/ClienteAssignacionHits';

class ClientesInfo extends Component {
  state = {};

  constructor(props) {
    super(props);

    const { id } = props.match.params;
    const { data = {} } = props.location.state || {};

    this.state = {
      busy: false,
      data: !!data.id ? { ...data } : { id },
    };

    props.reset();
    props.setPartialState({ data: this.state.data });
  }

  componentDidMount() {
    const { data } = this.state;

    if (!!data.id) {
      this.props.info(data.id);
    }
  }

  loginAs = () => {
    const original = Auth.getData();

    this.setState({
      busy: true,
    });

    Http.get(`api/clientes/${this.state.data.id}`, {
      params: { include: 'config,servicios,metadata,empresa.config,token' },
    })
      .then(
        async (response) => {
          const cliente = !!original.override ? { ...original.override, empresa: undefined } : { ...original.cliente };
          const empresa = !!original.override ? { ...original.override.empresa } : { ...original.empresa };

          const { access_token } = Auth.getToken() ?? {};
          const token = response.data?.token?.access_token ? { token: response.data?.token } : {};
          const data = {
            ...original,
            ...token,
            cliente: {
              ...response.data,
              empresa: undefined,
            },
            empresa: response.data.empresa,
            override: {
              ...cliente,
              token: { access_token },
              empresa: {
                ...empresa,
              },
            },
          };

          await Auth.setData(data);

          await window.resetApp();

          this.setState({
            busy: false,
          });

          this.props.history.replace('/bridge');
        },
        (error) => {
          window.ToastManager.show({
            variant: 'error',
            title: 'Sesión',
            message: error.message || 'Error recuperando información del cliente',
          });

          this.setState({
            busy: false,
          });
        }
      )
      .catch((error) => {
        window.ToastManager.show({
          variant: 'error',
          title: 'Sesión',
          message: error.message || 'Error recuperando información del cliente',
        });

        this.setState({
          busy: false,
        });
      });
  };

  render() {
    const { busy: switching } = this.state;
    const { result = {} } = this.props.hits;
    const { data = {}, busy } = this.props.cliente;

    const edit = {
      pathname: `/admin/clientes/${data.id}/editar`,
      state: {
        data: { ...data },
      },
    };

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader
          text="Clientes"
          to="/admin/clientes"
        />

        <h5>
          <Row>
            <Col>
              {!!busy && (
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  className="mr-3"
                >
                  <span className="sr-only">Loading client info...</span>
                </Spinner>
              )}
              {data.nombre_comercial || '...'}
            </Col>
            {Guardian.allows('cliente.editar') && (
              <Col
                xs={2}
                className="text-right"
              >
                <Link
                  className="text-muted"
                  to={edit}
                >
                  <small>Editar</small>
                </Link>
              </Col>
            )}
          </Row>
        </h5>

        {!!data.nombre_comercial && (
          <div>
            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Detalles</strong>
            </div>

            <ClienteTaxInfo data={data} />

            {Guardian.allows('cliente.cambiar.sesion') && (
              <div className="py-3">
                <div className="d-block">
                  <strong className="text-brand">INICIAR SESIÓN COMO...</strong>
                </div>

                <Row>
                  <Col>
                    <LoadingButton
                      type="button"
                      variant="danger"
                      disabled={switching}
                      loading={switching || false}
                      onClick={this.loginAs}
                    >
                      {switching === true ? 'Cambiando a...' : 'Cambiar sesión'}
                    </LoadingButton>
                  </Col>
                </Row>
              </div>
            )}

            {Guardian.allows('cliente.asignar.hits') && (
              <div className="py-3">
                <div className="d-block">
                  <strong className="text-brand">HITS</strong>
                </div>

                <Row className="mb-3">
                  <Col>
                    Actualmente cuenta <strong>{result.data?.hits ?? data.hits}</strong> disponibles
                  </Col>
                </Row>

                <ClienteAssignacionHits data={data} />
              </div>
            )}
          </div>
        )}
      </>
    );
  }
}

const mapState = (store) => {
  return {
    cliente: store.admin.clientes.info,
    hits: store.admin.clientes.hits,
  };
};

const mapActions = (actions) => {
  return actions.admin.clientes.info;
};

export default connect(useStore, mapState, mapActions)(ClientesInfo);
